import { gql } from '@apollo/client';

/**
 * Description - graphql query to delete an address
 */
export const DELETE_ADDRESS = gql`
  mutation update_qat_address_by_pk($id: Int!, $deletedDate: timestamptz!) {
    update_qat_address_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_date: $deletedDate }
    ) {
      id
    }
  }
`;
